module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAECAYAAAB2v+RhAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALUlEQVQYlWNkKPh/kIGBwY6B/uAQI0PB//8DYDEDAwMDA9NAWQyz/NgA2X0UAMFvBzCS5qLiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/firstPage/slider.png
// module id = lpow
// module chunks = 1